import { Form, Formik } from "formik";
import React from "react";
// import ModalWrapper from "../../app/common/modals/ModalWrapper";
import * as Yup from "yup";
import MyTextInput from "../../app/common/form/MyTextInput";
import { Button } from "@chakra-ui/button";
import { useSelector } from "react-redux";
// import { closeModal } from "../../app/common/modals/modalReducer";
import { signInWithEmail } from "../../app/firestore/firebaseService";
import SocialLogin from "./SocialLogin";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { Box, HStack, Link, Text } from "@chakra-ui/layout";
import { Stack } from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";

import { useHistory } from "react-router";

export default function LoginForm() {
  const history = useHistory();
  // const dispatch = useDispatch();
  const { prevLocation } = useSelector((state) => state.auth);
  const laststreamerUrl = localStorage.getItem("laststreamerUrl");

  function handleCancel() {
    // dispatch(closeModal());
    if (history && prevLocation) {
      history.push(prevLocation);
    } else {
      history.push("/settings");
    }
  }

  return (
    // <ModalWrapper size='mini' header='Login'>
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={Yup.object({
        email: Yup.string().required().email(),
        password: Yup.string().required(),
      })}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        try {
          await signInWithEmail(values);
          setSubmitting(false);
          // dispatch(closeModal());
          if (
            history &&
            prevLocation &&
            prevLocation.pathname !== "/recoverpassword"
          ) {
            history.push(prevLocation);
          } else {
            history.push(laststreamerUrl ? laststreamerUrl : "/");
          }
        } catch (error) {
          setErrors({ auth: "User not found or wrong password" });
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, isValid, dirty, errors }) => (
        <HStack>
          <Box w='45%' pr='30px'>
            <SocialLogin p='30px' />
          </Box>

          <Box w='10%' h='100%'>
            <Text fontStyle='italic' opacity='0.3'>
              or
            </Text>
          </Box>

          <Stack w='45%' pl='30px' borderLeft='1px solid rgba(255,255,255,0.2)'>
            <Form>
              <FormControl>
                <Stack spacing={5}>
                  <MyTextInput
                    name='email'
                    id='email'
                    // placeholder='Email Adress'
                    label='eMail'
                  />
                  <MyTextInput
                    name='password'
                    id='password'
                    // placeholder='Password'
                    type='password'
                    label='Password'
                  />
                  {errors.auth && (
                    <FormLabel
                      position='relative'
                      color='red'
                      style={{ marginBottom: 0 }}
                    >
                      {errors.auth}
                    </FormLabel>
                  )}

                  <HStack>
                    <Button
                      isLoading={isSubmitting}
                      isDisabled={!isValid || !dirty || isSubmitting ? 1 : 0}
                      type='submit'
                      id='id_submit'
                      variant='primary'
                      w={400}
                    >
                      Login
                    </Button>
                    <Button onClick={handleCancel} variant='outline' w={100}>
                      Cancel
                    </Button>
                  </HStack>
                  <Box>
                    <Box textAlign='right' fontSize='xs' mb='20px'>
                      <Link href='/recoverpassword'>Forgot your password?</Link>
                    </Box>
                    <Box>or</Box>
                    <Button variant='outline' as={ReactLink} to='/register'>
                      Create Account
                    </Button>
                  </Box>
                </Stack>
              </FormControl>
            </Form>
          </Stack>
        </HStack>
      )}
    </Formik>
    // </ModalWrapper>
  );
}
